var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import DocumentComparisonServiceApi from '~/api/submission-engine/documentComparisonService';
import { keysToCamel } from '~/utils/toCamelCase';
const getComparisonById = (compareId) => __awaiter(void 0, void 0, void 0, function* () {
    const response = keysToCamel(yield DocumentComparisonServiceApi.comparisonSearch({ compare_id: compareId }));
    if (response.status.toLowerCase() !== 'success') {
        console.error(response);
        throw Error('error fetching comparison');
    }
    if (response.data.length < 1)
        throw Error('No comparisons returned with ID provided');
    const comparison = response.data.find(c => c.compareId === compareId);
    if (!comparison)
        throw Error('No comparisons found in returned list with ID provided');
    return comparison.files;
});
export default getComparisonById;
